'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H3 from 'UIComponents/elements/headings/H3';
import UIList from 'UIComponents/list/UIList';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
const HUBSPOT_USER_GUIDE_LINK = 'https://knowledge.hubspot.com/website-pages/use-themes';

const NoopExternalIcon = () => null;

const ExternalLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
  ExternalIcon: NoopExternalIcon,
  external: true
}));

const ThemeResources = ({
  casesUrl,
  forumUrl,
  getThemeEventSelectorId = () => undefined,
  onTrackInteraction,
  setupUrl,
  supportUrl
}) => {
  const trackInteraction = useCallback((...args) => {
    if (onTrackInteraction) {
      onTrackInteraction(...args);
    }
  }, [onTrackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystemMarketplaceCore.themes.details.resources.title"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [/*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-SETUP-GUIDE'),
        href: setupUrl,
        onClick: () => trackInteraction('click setup guide link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lesson"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.resources.setupUrl"
        })]
      }), /*#__PURE__*/_jsxs(ExternalLink, {
        href: HUBSPOT_USER_GUIDE_LINK,
        onClick: () => trackInteraction('click user guide link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lesson"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.resources.userGuide"
        })]
      }), supportUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-SUPPORT-WEBSITE'),
        href: supportUrl,
        onClick: () => trackInteraction('click support website link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "website"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.resources.supportUrl"
        })]
      }), forumUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-COMMUNITY'),
        href: forumUrl,
        onClick: () => trackInteraction('click community link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lists"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.resources.forumUrl"
        })]
      }), casesUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getThemeEventSelectorId('SIDEBAR-CASE-STUDY'),
        href: casesUrl,
        onClick: () => trackInteraction('click case study link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "book"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.themes.details.resources.casesUrl"
        })]
      })]
    })]
  });
};

ThemeResources.propTypes = {
  casesUrl: PropTypes.string,
  forumUrl: PropTypes.string,
  getThemeEventSelectorId: PropTypes.func,
  onTrackInteraction: PropTypes.func,
  setupUrl: PropTypes.string.isRequired,
  supportUrl: PropTypes.string
};
export default ThemeResources;